module.exports = __webpack_public_path__ + "img/NRW_MWIDE.dd4c264d.svg";